<div [ngClass]="{'active': state}"
     class="burger"
     (click)="toggleState()">
  <button type="button">
    <div class="burger__icon">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <span class="burger__text">{{label}}</span>
  </button>
</div>
